import React from 'react';
import { ShimmerLoader, ShimmerLoaderProps } from '@guildeducationinc/recess';
import { useEmployerContent } from '@src/context/EmployerContentContext';
import { useMemberPlanContext } from '@src/context/MemberPlanContext';
import { useMemberTraitsContext } from '@src/context/MemberTraitsContext';

interface SkeletonProps extends Omit<ShimmerLoaderProps, 'loaded' | 'label'> {
  label?: string;
}

/**
 * Skeleton component to handle loading states. This will render a loading skeleton when the app is in a loading state, otherwise it will render `children`
 *
 * ```jsx
 * import { Skeleton } from '@shared/Skeleton';
 *
 * ...
 * <Skeleton>
 *   This will render when loaded
 * </Skeleton>
 * ```
 *
 * @packageDocumentation
 */

const Skeleton: React.FC<SkeletonProps> = ({ children, label = 'content', ...props }) => {
  const { loading: contentLoading } = useEmployerContent();
  const { loading: memberTraitsLoading } = useMemberTraitsContext();
  const { loading: memberPlanLoading } = useMemberPlanContext();

  const loading = contentLoading || memberTraitsLoading || memberPlanLoading;

  return (
    <ShimmerLoader {...props} label={label} loaded={!loading}>
      {children}
    </ShimmerLoader>
  );
};

export default Skeleton;
